module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAM1BMVEUAAACSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpLc3t+ZmZrr7e+kpaXm6Or9iTccAAAAC3RSTlMA8RTRU/mGgvPOVIKmBnoAAABZSURBVAjXXY9bDoAwCARpKW0VsL3/ad2QaJQJP5MlPAjUziI8KgWtaFBamL7AK7Llqr6QVxqwbe624Z0YgV2GQguTaHiYyl9nak6j0qJ0Bjg/Rz4vzCNeuAGrwAaPQpqvSAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_clear_active.png
// module id = fSFx
// module chunks = 9